import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=5f335818&scoped=true"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=ts"
import style0 from "./ArrowRightIcon.vue?vue&type=style&index=0&id=5f335818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f335818",
  null
  
)

export default component.exports